import { type OnInit, Component, inject } from '@angular/core';
import { FirebaseService } from '../../../core/services/firebase.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-float-button',
    template: `
  <span class="button-visible">
    @if (isButtonVisible$ | async) {
      <a href="#" class="float">
        <span class="material-icons my-float">
          expand_less
        </span>
      </a>
    }
  </span>
  `,
    styles: [`
  @media (max-width: 600px) {
    .button-visible{
     visibility: hidden;
    }

  }
  
  `],
    imports: [AsyncPipe]
})
export class FloatButtonComponent implements OnInit{
  private firebaseService = inject(FirebaseService);

  isButtonVisible$: ReturnType<FirebaseService['getFloatButton']>;
ngOnInit(){
  this.isButtonVisible$ = this.firebaseService.getFloatButton();
}
  
}
